"use client";
import { useMemo } from "react";
import { copyRawValuesOnly } from "../html/use-props";
import { buildSVGAttrs } from "./utils/build-attrs";
import { createSvgRenderState } from "./utils/create-render-state";
import { isSVGTag } from "./utils/is-svg-tag";
export function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = useMemo(() => {
        const state = createSvgRenderState();
        buildSVGAttrs(state, visualState, isSVGTag(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}
//# sourceMappingURL=use-props.js.map